import React from 'react';

interface Props {
  xmlns?: any;
  version?: any;
  viewBox?: any;
  width?: any;
  height?: any;
  className?: any;
}

const SvgIcon: React.FC<Props> = ({ children, xmlns, version, viewBox, width, height, className }) => (
  <svg xmlns={xmlns} version={version} viewBox={viewBox} width={width} height={height} className={className}>
    {children}
  </svg>
);

SvgIcon.defaultProps = {
  width: 50,
  height: 50,
  className: undefined,
};

export default SvgIcon;
